// extracted by mini-css-extract-plugin
export default {"SitemapPriority":"SitemapPriority--GAMgI"};